(function(){
  const variantPicker = document.querySelector(".product-information .variant-picker");
  if (!variantPicker) return;
  
  document.addEventListener("DOMContentLoaded", async () => {
    function handleVariantPickerOnLoad(event) {
      // Get variants and variantsInventoryLevels
      renderNewVariants(event, isOnLoad = true);
      document.removeEventListener('productAndVariantsInventoryOnLoad', handleVariantPickerOnLoad, false)
    };
    document.addEventListener('productAndVariantsInventoryOnLoad', handleVariantPickerOnLoad);
  });
  
  
  document.addEventListener("product:variant-change", () => {
    function handleVariantPickerOnChange(event) {
      renderNewVariants(event);
      document.removeEventListener('productOnChange', handleVariantPickerOnChange)
    }
    document.addEventListener('productOnChange', handleVariantPickerOnChange);
  });
  
  
  function isVariantAvailable(variantsInventoryLevels, index, inventoryPolicy) {
    const res = variantsInventoryLevels[index].inventory_quantities.find(({ level }) => level > 0) || -1;
    if (res === -1) {
      if (inventoryPolicy === 'continue') {
        return true;
      } else {
        return false;
      }
    } else {
      return true;
    }
  }
  
  function clearVariantPickerAndGetCheckedVariant(variantPicker) {
    let firstChild = variantPicker.firstElementChild
    let checkedVariant = null;
    while (firstChild) {
      if (firstChild.checked) checkedVariant = firstChild.value;
      firstChild.remove()
      firstChild = variantPicker.firstElementChild
    }
    return checkedVariant;
  }
  
  function renderNewVariants(event, isOnLoad = false) {
    const template = document.querySelector('template#size-variant-template');
    if (!template) return;
    const { product: { product: { variants } } , variantsInventoryLevels } = event.detail;
  
    const { content } = template;
    const variantInput = content.querySelector('input');
    const variantLabel = content.querySelector('label');
    const { dataset: { 
      section_id, 
      optionPosition, 
      sticky 
    } } = variantInput;
  
    // Clear variant picker and get checked variant
    if (!variants) return;
    const checkedVariant = clearVariantPickerAndGetCheckedVariant(variantPicker);
    document.querySelector('.variations .form__label__value').innerText = checkedVariant;
  
    let isFirstVariant = true;  
    variants.forEach((variant, index) => {

      // Construct new variant input and label
      const variantInputClone = variantInput.cloneNode(true);
      variantInputClone.setAttribute('id', `${section_id}-${optionPosition}-${index}${sticky ? '--sticky' : ''}`)
      variantInputClone.setAttribute('form', `product-form-${section_id}`)
      variantInputClone.setAttribute('value', variant.title);
      if (variant.title === checkedVariant) variantInputClone.setAttribute('checked', true);
  
      const variantLabelClone = variantLabel.cloneNode(true);
      variantLabelClone.setAttribute('for', `${section_id}-${optionPosition}-${index}${sticky ? '--sticky' : ''}`);
      variantLabelClone.querySelector('span').innerText = variant.title;
      variantLabelClone.setAttribute('data-index', index);
      variantPicker.appendChild(variantInputClone);
      // Variants inventory and product variants come in the same order so we can use the same index
      // The variant will be labeled as "sold-out" if no store has it in stock 
      if (!isVariantAvailable(variantsInventoryLevels, index, variant.inventory_policy)) {
        variantLabelClone.classList.add('sold-out')
        variantPicker.appendChild(variantLabelClone);
      }
      else {
        variantPicker.appendChild(variantLabelClone);
      }
  
      if (isFirstVariant && isOnLoad) {
        isFirstVariant = false;
      }
    });
    variantPicker.classList.remove('hide-default-variants');
  }
})();
